import React from 'react';
import PropTypes from 'prop-types';
import styleable from 'react-styleable';
import { injectIntl, intlShape } from 'react-intl';
import { Plus } from '../../helpers/icon-dictionary';
import css from './index.scss';
import Button from '../../components/button/index';
import StudentClassList from '../student-class-list/index';
import messages from './messages';

const StudentClassDetail = ({
    editStudentDetail,
    handleOnUnassignStudent,
    productName,
    isUnassignedModalOpen,
    handleOnUnassignConfirm,
    handleOnCloseModal,
    unassignStudentsSuccessConfirmation,
    showUnassignStudentModal,
    isLoading,
    handleOnAssignClass,
    intl }) => {
    const assignedClassrooms = editStudentDetail !== undefined ? editStudentDetail.assignedClassrooms : [];
    return (
        <div className={css.classDetailComponent}>
            <div className={css.title}>{intl.formatMessage(messages.classDetails)} ({productName})</div>
            <div className={css.header}>
                <StudentClassList
                    assignedClassrooms={assignedClassrooms}
                    handleOnCloseModal={handleOnCloseModal}
                    handleOnStudentUnassign={handleOnUnassignStudent}
                    handleOnUnassignConfirm={handleOnUnassignConfirm}
                    isLoading={isLoading}
                    isUnassignedModalOpen={isUnassignedModalOpen}
                    showUnassignStudentModal={showUnassignStudentModal}
                    unassignStudentsSuccessConfirmation={unassignStudentsSuccessConfirmation} />
            </div>
            <div className={css.footer}>
                <Button
                    containerClassName={css.assignClass}
                    handleOnClick={handleOnAssignClass}
                    icon={Plus}
                    iconClassName={css.icon}
                    label={intl.formatMessage(messages.assignClasses)} />
            </div>
        </div>
    );
};

StudentClassDetail.propTypes = {
    editStudentDetail: PropTypes.object,
    productName: PropTypes.string,
    handleOnUnassignStudent: PropTypes.func,
    handleOnUnassignConfirm: PropTypes.func,
    handleOnCloseModal: PropTypes.func,
    unassignStudentsSuccessConfirmation: PropTypes.func,
    isUnassignedModalOpen: PropTypes.bool,
    showUnassignStudentModal: PropTypes.bool,
    isLoading: PropTypes.bool,
    intl: intlShape.isRequired,
    handleOnAssignClass: PropTypes.func
};

export default injectIntl(styleable(css)(StudentClassDetail));



// WEBPACK FOOTER //
// ./app/components/student-class-detail/index.js